import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { Icon } from '@seeqdev/qomponents';

interface ToggleSwitchProps {
  isOn: boolean;
  onChange: (newValue: boolean) => void;
  label?: string;
  formattedLabel?: React.ReactNode;
  disabled?: boolean;
  testId?: string;
  extraClassNames?: string;
}

/**
 * Generic two-state toggle button (on/off)
 */
export const ToggleSwitch = (props: ToggleSwitchProps) => {
  const { isOn, onChange, label, formattedLabel, disabled = false, testId = 'toggleSwitch', extraClassNames } = props;

  const { t } = useTranslation();

  return (
    <div
      data-testid={testId}
      className={clsx(
        {
          flexColumnContainer: !extraClassNames,
          flexCenter: !extraClassNames,
        },
        extraClassNames,
        {
          disabledBehavior: disabled,
        },
      )}
      onClick={(e) => {
        e.stopPropagation();
        return !disabled && onChange(!isOn);
      }}>
      <span className={clsx({ disabled })}>{formattedLabel ? formattedLabel : t(label ?? '')}</span>
      <Icon
        testId={`${testId}Icon`}
        icon={isOn ? 'fa-toggle-on' : 'fa-toggle-off'}
        iconPrefix="fa-solid"
        large={true}
        extraClassNames={clsx('cursorPointer', {
          ml7: label || formattedLabel,
          disabled,
        })}
      />
    </div>
  );
};
